// components/chat/ChatInputForm.js
import React from 'react';
import './ChatInputForm.css';

const ChatInputForm = ({
  inputValue,
  handleInputChange,
  handleSubmit,
  isLoading,
  textareaRef,
  fileInputRef,
  handleAttachmentClick,
  handleFileChange
}) => {
  
  return (
    <div className="chat-input-container">
      <form className="chat-input-form" onSubmit={handleSubmit}>
        {/* Hidden file input */}
        <input
          type="file"
          ref={fileInputRef}
          className="hidden-file-input"
          onChange={handleFileChange}
          multiple
          style={{ display: 'none' }}
        />
        
        {/* Attachment button */}
        <button 
          type="button" 
          className="attachment-button"
          onClick={handleAttachmentClick}
          title="Attach file"
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48" 
              stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        <textarea
          ref={textareaRef}
          className="chat-input"
          value={inputValue}
          onChange={handleInputChange}
          placeholder="Message AI... (Type /prompt: for test case creation from scratch)"
          onKeyDown={(e) => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              handleSubmit(e);
            }
          }}
        />
        <button 
          type="submit" 
          className="send-button"
          disabled={isLoading || !inputValue.trim()}
        >
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 2L11 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </form>
      <div className="input-footer">
        <p className="input-note">Shift + Enter for new line • Enter to send</p>
      </div>
    </div>
  );
};

export default ChatInputForm;